<button mat-icon-button class="close-button" mat-dialog-close="false">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h2 mat-dialog-title>
  Report an Order - 
  <strong>{{order.OrderNo}}</strong>
</h2>

<form [formGroup]="reportOrderForm" #formDirective="ngForm" (submit)="fn_Submit()" autocomplete="off">
  <mat-dialog-content>
    <div class="mat-crd-ui report-bug">
      <mat-form-field class="example-full-width">
        <mat-label>Select the products which have the problem *</mat-label>
        <mat-select panelClass="mat-select-PanelClass" formControlName="orderItems" multiple>
          <mat-option *ngFor="let item of order.OrderItems" [value]="item.CartItemId">{{item.DesignName}} ({{item.ColorName}}, {{item.SizeName}})</mat-option>
        </mat-select>
        <mat-error *ngIf="f.orderItems.touched && f.orderItems.invalid && f.orderItems.pristine">
          <strong>Select at least one item</strong>
        </mat-error>
        <mat-error *ngIf="!f.orderItems.valid && (f.orderItems.touched && f.orderItems.dirty)">
          <strong>Select at least one item</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Select problem type *</mat-label>
        <mat-select panelClass="mat-select-PanelClass" formControlName="problemTypes" multiple>
          <mat-option *ngFor="let item of problemTypes" [value]="item">{{item}}</mat-option>
        </mat-select>
        <mat-error *ngIf="f.problemTypes.touched && f.problemTypes.invalid && f.problemTypes.pristine">
          <strong>Select at least one item</strong>
        </mat-error>
        <mat-error *ngIf="!f.problemTypes.valid && (f.problemTypes.touched && f.problemTypes.dirty)">
          <strong>Select at least one item</strong>
        </mat-error>
      </mat-form-field>

      <mat-form-field class="example-full-width">
        <mat-label>Notes *</mat-label>
        <textarea matInput formControlName="notes" rows="6" required></textarea>
        <mat-hint>Detailed description of the problems found within these order items.</mat-hint>
        <mat-error *ngIf="f.notes.touched && f.notes.invalid && f.notes.pristine">
          <strong>Required</strong>
        </mat-error>
        <mat-error *ngIf="!f.notes.valid && (f.notes.touched && f.notes.dirty)">
          <strong>Required</strong>
        </mat-error>
      </mat-form-field>

      <div class="image-div">
        <input #fileInput class="file-upload" formControlName="file" id="file" type="file" multiple=""
          (change)="onFileChange($event)" accept="image/*" style="display: none;">
        <div class="file-upload">
          <button type="button" matTooltip="Upload images" mat-mini-fab color="primary" class="upload-btn"
            (click)="fileInput.click()">
            <mat-icon>attach_file</mat-icon>
          </button>
          {{fileName || "No file uploaded yet."}}
        </div>
        <div>
          <small class="text-muted">*Please attach the image(s) of the selected order items.</small>
        </div>
        <div>
          <mat-hint align="start">*Size should be less than 5 MB</mat-hint>
        </div>
        <div>
          <img class="display-files img-upload-thumb" *ngFor="let url of images" [src]="url" height="100" width="100">
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="no-delete" mat-dialog-close="false">Cancel</button>
    <button type="submit" class="mat-raised-button mat-primary" [disabled]="reportOrderForm.invalid" cdkFocusInitial>Save</button>
  </mat-dialog-actions>
</form>